import { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card, CardContent } from '@mui/material';
import { School } from '@mui/icons-material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Contacts from '../../../assets/images/import_contacts_custom.svg';
import { getUsersCount } from '../../../API/Statistics';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const Infographics1 = () => {
    const [statistics, setStats] = useState({
        instructors: 0,
        students: 0,
        labAssistants: 0
    });

    useEffect(() => {
        getUsersCount().then((response) => {
            if (response) {
                setStats(response);
            }
        });
    }, []);

    const labels = ['User Roles Breakdown'];
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: 'Platform User Statistics'
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0
                }
            }
        }
    };

    const data = {
        labels,
        datasets: [
            {
                label: 'Instructors',
                data: [statistics?.instructors || 0],
                backgroundColor: 'rgba(82, 146, 221, 0.8)'
            },
            {
                label: 'Students',
                data: [statistics?.students || 0],
                backgroundColor: 'rgb(82, 146, 221)'
            },
            {
                label: 'Lab Assistants',
                data: [statistics?.labAssistants || 0],
                backgroundColor: 'rgba(54, 162, 235, 0.6)'
            }
        ]
    };

    return (
        <Box>
            <Card>
                <CardContent>
                    <Bar options={options} data={data} />
                </CardContent>
            </Card>
        </Box>
    );
};

export default Infographics1;
